import React, {useState} from 'react'
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import Test01 from '../../../assets/images/OLD.png';
import Test02 from '../../../assets/images/testimonial/testimonial-1.png';
import Test03 from '../../../assets/images/testimonial/testimonial-2.png';
import Test04 from '../../../assets/images/testimonial/testimonial-3.png';
import Test05 from '../../../assets/images/testimonial/testimonial-4.png';

const Testimonialone = () => {
    const [ytshow, setytshow] = useState(false);
    const Testimonialslider = {
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false
    }
    return (
        <>
            <section className="testimonial-one white-font">
                <div className="container">
                    <div className="row gutter-y-30">
                        <div className="col-lg-4 col-md-6 col-sm-10 col-12 ms-auto me-auto">
                            <div className="testimonial-video-one">
                                <img
                                    src={Test01}
                                    alt="testimonial-video-thamb"
                                />
                                {/* <Link
                                    to="#"
                                    className="testimonial-video-btn-one" onClick={() => setytshow(true)}
                                >
                                    
                                </Link> */}
                            </div>
                        </div>
                        <div className="col-lg-8 align-self-center">
                            <div className="testimonial-one-right">
                                <div className="heading-box heading-white text-black" id='testimonials'>
                                    <span className="heading-subtitle wow fadeInUp animated animated text-black">
                                        🤝 TESTIMONIAL
                                    </span>
                                    <h2 className="heading-title wow fadeInUp animated animated text-black">
                                    Heartfelt words from our valued clients
                                    </h2>
                                </div>
                                <Slider className="testimonial-slider-one" {...Testimonialslider}>
                                    <div className="testimonial-one-item">
                                        <p id='paragraph'>
                                         
						The NRI Advisors made my dream of buying a home in India a reality while I was still in the U.S. Their team was incredibly responsive and handled every detail with professionalism and care. I was constantly updated with photos and reports, which made the whole process seamless and stress-free. Truly a remarkable service.					
                                        </p>
                                        <div className="testimonial-one-details-inner">
                                            <div className="testimonial-one-details">
                                                {/* <img
                                                    src={Test02}
                                                    alt="Testimonial-image"
                                                /> */}
                                                <div>
                                                    <h5 className="white-font">Aditya, USA</h5>
                                                    {/* <p className="white-font m-0">USA</p> */}
                                                </div>
                                            </div>
                                            <i className="flaticon-quote-1" />
                                        </div>
                                    </div>
                                    <div className="testimonial-one-item">
                                        <p id='paragraph'>
                                         
					
                                        I needed help managing my family's property back home, and The NRI Advisors exceeded all my expectations. They ensured everything was maintained perfectly and even took care of legal notices and local compliances. Their service is a lifeline for NRIs like me who are far from home but still need to manage their assets.										
                                        </p>
                                        <div className="testimonial-one-details-inner">
                                            <div className="testimonial-one-details">
                                                {/* <img
                                                    src={Test02}
                                                    alt="Testimonial-image"
                                                /> */}
                                                <div>
                                                    <h5 className="white-font">Amrit, Australia</h5>
                                                    {/* <p className="white-font m-0">USA</p> */}
                                                </div>
                                            </div>
                                            <i className="flaticon-quote-1" />
                                        </div>
                                    </div>
                                    <div className="testimonial-one-item">
                                        <p id='paragraph'>
                                         
					
                                        The Team At The NRI Advisors Helped Us Navigate The Complexities Of Obtaining OCI Status For Our Family. Their Attention To Detail And Prompt Responses Made The Whole Process Smooth And Efficient. We Couldn't Have Done It Without Their Expert Guidance.

                                        </p>
                                        <div className="testimonial-one-details-inner">
                                            <div className="testimonial-one-details">
                                                {/* <img
                                                    src={Test02}
                                                    alt="Testimonial-image"
                                                /> */}
                                                <div>
                                                    <h5 className="white-font">Akansha, USA</h5>
                                                    {/* <p className="white-font m-0">USA</p> */}
                                                </div>
                                            </div>
                                            <i className="flaticon-quote-1" />
                                        </div>
                                    </div>
                                    <div className="testimonial-one-item">
                                        <p id='paragraph'>
                                         
						
                                        The NRI Advisors' tax planning and compliance services are top-notch. They handled my global income tax filings flawlessly and provided valuable advice on minimizing my liabilities. Their expertise saved me a significant amount of money and gave me peace of mind. Highly recommend them!										
                                        </p>
                                        <div className="testimonial-one-details-inner">
                                            <div className="testimonial-one-details">
                                                {/* <img
                                                    src={Test02}
                                                    alt="Testimonial-image"
                                                /> */}
                                                <div>
                                                    <h5 className="white-font">Veer, Canada</h5>
                                                    {/* <p className="white-font m-0">USA</p> */}
                                                </div>
                                            </div>
                                            <i className="flaticon-quote-1" />
                                        </div>
                                    </div>
                                    <div className="testimonial-one-item">
                                        <p id='paragraph'>
                                         
					
                                        The NRI Advisors were instrumental in setting up our company in India. From incorporation to compliance with local laws, they took care of everything. Their comprehensive approach and thorough knowledge of regulatory requirements made our expansion into the Indian market hassle-free. Exceptional service!										
                                        </p>
                                        <div className="testimonial-one-details-inner">
                                            <div className="testimonial-one-details">
                                                {/* <img
                                                    src={Test02}
                                                    alt="Testimonial-image"
                                                /> */}
                                                <div>
                                                    <h5 className="white-font">Heena Kakkar, Canada</h5>
                                                    {/* <p className="white-font m-0">USA</p> */}
                                                </div>
                                            </div>
                                            <i className="flaticon-quote-1" />
                                        </div>
                                    </div>
                                    <div className="testimonial-one-item">
                                        <p id='paragraph'>
                                         
						
                                        I had a wonderful experience with The NRI Advisors' marriage support services. They helped us with everything from arranging outfits to coordinating wedding functions. Their dedication and efficiency ensured that our big day was perfect and stress-free. Thank you for making our celebration unforgettable!										
                                        </p>
                                        <div className="testimonial-one-details-inner">
                                            <div className="testimonial-one-details">
                                                {/* <img
                                                    src={Test02}
                                                    alt="Testimonial-image"
                                                /> */}
                                                <div>
                                                    <h5 className="white-font">Amandeep Singh, UK</h5>
                                                    {/* <p className="white-font m-0">USA</p> */}
                                                </div>
                                            </div>
                                            <i className="flaticon-quote-1" />
                                        </div>
                                    </div>
                                    <div className="testimonial-one-item">
                                        <p id='paragraph'>
                                            
						The digital marketing services provided by The NRI Advisors have significantly boosted my business's online presence. Their team crafted an effective strategy that attracted the right audience and drove impressive results. The analytics and reporting they provided were detailed and insightful, helping us continuously improve. I highly recommend their services.					
                                        </p>
                                        <div className="testimonial-one-details-inner">
                                            <div className="testimonial-one-details">
                                                {/* <img
                                                    src={Test03}
                                                    alt="Testimonial-image"
                                                /> */}
                                                <div>
                                                    <h5 className="white-font">Parminder Singh, Australia</h5>
                                                    <p className="white-font m-0">Satisfied Client</p>
                                                </div>
                                            </div>
                                            <i className="flaticon-quote-1" />
                                        </div>
                                    </div>
                                    <div className="testimonial-one-item">
                                        <p id='paragraph'>
                                            
						The NRI Advisors’ architectural and interior design services transformed our house into a stunning home. Their innovative designs and attention to detail were impeccable. The project management was smooth, and we loved the 3D visualizations that helped us see the final look before implementation. Highly recommend their expertise!					
                                        </p>
                                        <div className="testimonial-one-details-inner">
                                            <div className="testimonial-one-details">
                                                {/* <img
                                                    src={Test04}
                                                    alt="Testimonial-image"
                                                /> */}
                                                <div>
                                                    <h5 className="white-font">Deepjot Singh, UK</h5>
                                                    {/* <p className="white-font m-0">Satisfied Client</p> */}
                                                </div>
                                            </div>
                                            <i className="flaticon-quote-1" />
                                        </div>
                                    </div>
                                    <div className="testimonial-one-item">
                                        <p id='paragraph'>
                                           
						Working with NRI Advisors on our financial planning and tax compliance has been a game-changer. Their knowledgeable team provided invaluable advice on investment strategies and tax-saving opportunities. Their proactive approach and thorough understanding of regulations gave us confidence and clarity in our financial decisions.					
                                        </p>
                                        <div className="testimonial-one-details-inner">
                                            <div className="testimonial-one-details">
                                                {/* <img
                                                    src={Test05}
                                                    alt="Testimonial-image"
                                                /> */}
                                                <div>
                                                    <h5 className="white-font">Harry, New Zealand</h5>
                                                    {/* <p className="white-font m-0">Satisfied Client</p> */}
                                                </div>
                                            </div>
                                            <i className="flaticon-quote-1" />
                                        </div>
                                    </div>
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {ytshow &&
            <div className="YouTubePopUp-Wrap">
                <div className="YouTubePopUp-Content">
                    <span className="YouTubePopUp-Close" onClick={() => setytshow(false)}/>
                    <iframe
                        src="https://www.youtube.com/embed/rzfmZC3kg3M?autoplay=1"
                        allowFullScreen="allowfullscreen"
                    />
                </div>
            </div>
        }
        </>
    )
}
export default Testimonialone;